export const startOfCalendarDay = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

// All-day API end is exclusive (midnight on the day after the last included day).
// SDK sometimes sometimes send end as before start, so we need to handle this.
export const toAllDayDisplayEndDate = (start: Date, end: Date): Date => {
    const startDay = startOfCalendarDay(start);
    const endDay = startOfCalendarDay(end);

    if (endDay.getTime() > startDay.getTime()) {
        const displayEnd = new Date(endDay);
        displayEnd.setDate(displayEnd.getDate() - 1);

        return displayEnd;
    }

    return new Date(startDay);
};

export const toAllDayDisplayDates = (
    start: Date,
    end: Date,
): { start: Date; end: Date } => ({
    start: startOfCalendarDay(start),
    end: toAllDayDisplayEndDate(start, end),
});

export const toAllDayApiEndDate = (inclusiveEndDate: Date): Date => {
    const apiEnd = startOfCalendarDay(inclusiveEndDate);
    apiEnd.setDate(apiEnd.getDate() + 1);

    return apiEnd;
};
